import RingHand from '../../src/legacy/RingHand';
export default RingHand;
